export default {"src":"/_next/static/media/10.97412219.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};